'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _reactI18next = require('react-i18next');
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _numbers = require('../../helpers/numbers');
var _misc = require('../../helpers/misc');
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
require('moment/locale/fr');
require('moment/locale/es');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultShowPrice = true;
var defaultColours = [{
  r: '94',
  g: '52',
  b: '98'
}, {
  r: '192',
  g: '65',
  b: '94'
}, {
  r: '0',
  g: '178',
  b: '166'
}];
var styles = {
  loader: {
    display: 'block',
    margin: '2rem auto'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  gridContainer: {
    margin: '2.5rem 0'
  },
  gridItem: {
    backgroundColor: '#EFEFEF',
    color: '#707070',
    margin: '1rem 0',
    padding: function padding(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '1rem' : '2rem';
    },
    borderRadius: '8px',
    borderLeftWidth: function borderLeftWidth(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '1.5rem' : '1rem';
    },
    borderLeftStyle: 'solid',
    minHeight: '10rem',
    display: 'flex',
    justifyContent: 'flex-start',
    '& .left-info': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: function justifyContent(_ref3) {
        var showPrice = _ref3.otherProperties.showPrice;
        return showPrice != undefined ? showPrice ? 'space-between' : 'center' : 'space-between';
      },
      textAlign: 'center',
      padding: function padding(_ref4) {
        var responsiveMode = _ref4.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '0 0.8rem 0 0' : '0 1rem 0 0';
      },
      minWidth: function minWidth(_ref5) {
        var responsiveMode = _ref5.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '6.4rem' : '9rem';
      },
      '& .AvailabilityInfo': {
        display: 'flex',
        flexDirection: 'column',
        fontSize: 'small',
        '& .AvailabilityNumber': {
          marginTop: '0px'
        },
        '& .AvailabilityText': {
          marginBottom: '0px'
        }
      }
    },
    '& .right-info': {
      padding: function padding(_ref6) {
        var responsiveMode = _ref6.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '0 0 0 0.8rem' : '0 0 0 1rem';
      }
    }
  },
  button: {
    fontFamily: 'inherit',
    fontSize: function fontSize(_ref7) {
      var responsiveMode = _ref7.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '13px' : '18px';
    },
    borderRadius: '30px',
    margin: '0',
    boxShadow: 'none',
    color: 'white',
    pointerEvents: function pointerEvents(_ref8) {
      var editable = _ref8.editable;
      return editable ? 'none' : 'auto';
    },
    fontWeight: 'bold',
    '&:hover': {}
  },
  title: {
    fontSize: function fontSize(_ref9) {
      var responsiveMode = _ref9.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '16px' : '22px';
    },
    fontWeight: 'bold'
  },
  titlePrice: {
    fontSize: function fontSize(_ref10) {
      var responsiveMode = _ref10.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '16px' : '22px';
    },
    fontWeight: 'bold',
    display: 'block',
    textAlign: 'center'
  },
  subTitle: {
    fontSize: function fontSize(_ref11) {
      var responsiveMode = _ref11.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '14px' : '16px';
    },
    fontWeight: 'bold',
    display: 'block'
  },
  description: {
    fontSize: function fontSize(_ref12) {
      var responsiveMode = _ref12.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '14px' : '15px';
    },
    textAlign: 'left'
  }
};
var RegistrationTypeMulticolor = function (_Component) {
  _inherits(RegistrationTypeMulticolor, _Component);
  function RegistrationTypeMulticolor() {
    var _ref13;
    var _temp, _this, _ret;
    _classCallCheck(this, RegistrationTypeMulticolor);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref13 = RegistrationTypeMulticolor.__proto__ || Object.getPrototypeOf(RegistrationTypeMulticolor)).call.apply(_ref13, [this].concat(args))), _this), _this.getJSONRGB = function (style, value) {
      return _defineProperty({}, style, 'rgb(' + value.r + ',' + value.g + ',' + value.b + ')');
    }, _this.setBorderLeftStyle = function (i) {
      var coloursSelector = _this.props.otherProperties.coloursSelector;
      var _coloursSelector$i = coloursSelector[i],
        r = _coloursSelector$i.r,
        g = _coloursSelector$i.g,
        b = _coloursSelector$i.b,
        a = _coloursSelector$i.a;
      return {
        borderLeftColor: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
      };
    }, _this.setBgStyle = function (i) {
      var coloursSelector = _this.props.otherProperties.coloursSelector;
      var _coloursSelector$i2 = coloursSelector[i],
        r = _coloursSelector$i2.r,
        g = _coloursSelector$i2.g,
        b = _coloursSelector$i2.b,
        a = _coloursSelector$i2.a;
      return {
        backgroundColor: 'rgba(' + r + ',' + g + ',' + b + ', ' + a + ')',
        color: '#EFEFEF !important'
      };
    }, _this.renderAvailability = function (value) {
      var t = _this.props.t;
      return _react2.default.createElement('div', {
        className: 'AvailabilityInfo'
      }, _react2.default.createElement('p', {
        className: 'AvailabilityText'
      }, t('registration.available_seats')), _react2.default.createElement('p', {
        className: 'AvailabilityNumber'
      }, value));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegistrationTypeMulticolor, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        pagination = _props.pagination,
        t = _props.t,
        responsiveMode = _props.responsiveMode,
        otherProperties = _props.otherProperties;
      var showPrice = otherProperties.showPrice,
        showVAT = otherProperties.showVAT,
        registerButtonLabel = otherProperties.registerButtonLabel,
        showAvailability = otherProperties.showAvailability,
        coloursSelector = otherProperties.coloursSelector,
        displayedAttendeeTypes = otherProperties.displayedAttendeeTypes;
      var events = entities.events,
        attendee_types = entities.attendee_types;
      var isFetching = pagination.isFetching;
      var event = Object.keys(events).map(function (k) {
        return events[k];
      })[0];
      var eventUri = event.eventUri,
        eventId = event.id;
      var attendeeTypeIds = (0, _misc.filterAndSortAttendeeTypes)(attendee_types, displayedAttendeeTypes);
      var item_size = null;
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
          item_size = 10;
          break;
        case _ResponsiveModes.TABLET:
          item_size = 10;
          break;
        case _ResponsiveModes.MOBILE:
        default:
          item_size = 11;
      }
      return _react2.default.createElement('div', {
        className: classes.container
      }, _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.gridContainer,
        spacing: 0,
        justify: 'center'
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.loader
      }) : !!attendeeTypeIds.length ? attendeeTypeIds.map(function (attendee_type, index) {
        return _react2.default.createElement(_Grid2.default, {
          key: attendee_type,
          item: true,
          xs: item_size,
          className: classes.gridItem,
          style: coloursSelector && coloursSelector.length && coloursSelector.length > 0 ? _this2.setBorderLeftStyle(index % coloursSelector.length) : _this2.getJSONRGB('borderLeftColor', defaultColours[index % 3])
        }, _react2.default.createElement('div', {
          className: 'left-info'
        }, (showPrice === undefined && defaultShowPrice || showPrice != undefined && showPrice) && _react2.default.createElement('div', {
          className: 'price-container'
        }, _react2.default.createElement('span', {
          className: classes.titlePrice
        }, showVAT === undefined ? !!parseFloat(attendee_types[attendee_type].price) ? '' + (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].price) : t('event.price.free') : showVAT ? !!parseFloat(attendee_types[attendee_type].price) ? '' + (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].price) : t('event.price.free') : !!parseFloat(attendee_types[attendee_type].priceWithoutVat) ? '' + (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].priceWithoutVat) : t('event.price.free')), _react2.default.createElement('span', {
          className: classes.subTitle
        }, !!parseFloat(attendee_types[attendee_type].price) && '' + event.currency)), !!showAvailability && (!!attendee_types[attendee_type].capacity ? _this2.renderAvailability(parseFloat(attendee_types[attendee_type].availability)) : _react2.default.createElement('p', {
          className: 'AvailabilityNumber'
        }, t('registration.no_limit'))), _react2.default.createElement(_Button2.default, {
          variant: 'contained',
          className: classes.button,
          style: coloursSelector && coloursSelector.length && coloursSelector.length > 0 ? _this2.setBgStyle(index % coloursSelector.length) : _this2.getJSONRGB('backgroundColor', defaultColours[index % 3]),
          target: eventUri === 'soirees-formation-a-derma' ? '_self' : '_blank',
          href: _urls2.default.getPublicRegisterUrl(eventUri, attendee_type, parseInt(eventId)),
          disabled: !!parseInt(attendee_types[attendee_type].capacity) && !parseInt(attendee_types[attendee_type].availability)
        }, !!registerButtonLabel && registerButtonLabel != '' ? registerButtonLabel : t('registration.register'))), _react2.default.createElement('div', {
          className: 'right-info'
        }, _react2.default.createElement('div', {
          className: classes.title
        }, attendee_types[attendee_type].name), _react2.default.createElement('div', {
          className: classes.description,
          dangerouslySetInnerHTML: {
            __html: attendee_types[attendee_type].description
          }
        })));
      }) : _react2.default.createElement('h3', null, 'No attendee types :(')));
    }
  }]);
  return RegistrationTypeMulticolor;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(RegistrationTypeMulticolor));